// extracted by mini-css-extract-plugin
export var quillEditor = "_oz-1";
export var variable = "_oz-0";